// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"318":"23d2e388","392":"700357c2","443":"3217113f"}[chunkId] + ".chunk.js";
};